import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { SortHelper } from '@core/helpers/sort.helper';
import { TranslateService } from '@ngx-translate/core';
import { EstimateService } from '@shared/services/estimate.service';
import { UserService } from '@shared/services/user.service';
import { Table } from 'primeng/table';
import { combineLatest } from 'rxjs';
import { ClassTableRow } from './models/class-table.row';

@Component({
  selector: 'pop-class-table',
  templateUrl: './class-table.component.html',
  styleUrls: ['./class-table.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ClassTableComponent extends BaseComponent implements OnInit {
  public classificationEstimates: ClassTableRow[];
  public currentLang: string;
  @Input() public functionalCurrencySymbol: string;

  public constructor(
    private estimateService: EstimateService,
    private userService: UserService,
    private translateService: TranslateService
  ) {
    super();
    this.currentLang = this.translateService.currentLang;
  }

  public ngOnInit() {
    this.subscribe(
      combineLatest([this.estimateService.observeCurrentEstimate(), this.userService.getUser()]).subscribe(
        ([currentEstimate, user]) => {
          this.classificationEstimates = SortHelper.sortArrayByProperty(
            currentEstimate.classificationEstimates,
            o => o.classification?.code
          ).map(c => new ClassTableRow(c));

          this.currentLang = user.languageCode ?? this.translateService.currentLang;
        }
      )
    );
  }

  public filterTable(table: Table, eventTarget: EventTarget) {
    const input = eventTarget as HTMLInputElement;
    table.filterGlobal(input.value, 'contains');
  }
}
